<template>
  <div id="welcome_menu"
    :class="[(this.$lang === 'ar' ? 'left-menu' : 'right-menu'), !$store.state.user.gsm ? 'flex-center' : '', 'gray-gradient-bottom0 border-white-1-50']"
    :style="[($store.state.window < 800 ? { left: 'calc(50% - 150px)', top: 'calc(50% - 197.5px)' } : $store.state.window < 1100 ? { transform: 'translate(-50%, -50%)', left: 'calc(50%)', top: 'calc(50%)' } : $store.state.window < 500 ? { top: '20px' } : {}), (height < 500 && { top: '100px' }), ($store.state.user.gsm ? { height: 'auto' } : { height: '380px' })]"
    v-click-outside="closeOutside">
    <div v-if="!$store.state.user.gsm" class="m-auto">
      <div class="dialog-title">{{ $t('welcomeMenu.welcome') }}</div>
      <div class="desc">{{ desc }}</div>
      <div class="rec-button yellow-back border-white-1-50 flex-center black-outset-1"
        v-on:click="$store.state.loginDialog = true" style="margin-bottom: 1.5rem">
        {{ $t('welcomeMenu.login') }} <div class="white-b"></div>
      </div>
      <div class="desc">{{ $t('welcomeMenu.newCustomer') }} <br />{{ $t('welcomeMenu.deals') }}</div>
      <div class="rec-button border-white-1-50 flex-center gray-gradient-bottom0 black-outset-1"
        @click="$store.state.registerDialog = true">{{ $t('welcomeMenu.register') }}</div>
    </div>
    <div class="registered-form right-dir" v-if="$store.state.user.gsm !== null">
      <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'name']">{{ name }}</div>

      <!-- Profile link with validation -->
      <div
        @click="handleProfileClick"
        :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'show-profile', !isValidNumber($store.state.selectedNumber) ? 'disabled-link' : '']"
        :style="!isValidNumber($store.state.selectedNumber) ? { cursor: 'not-allowed', opacity: '0.6' } : {}">
        {{ $t('profile.showProfile') }}
      </div>

      <!-- Only show numbers that start with 09 -->
      <div @click="checkNumber(i, number.gsm)"
        v-for="(number, i) in filteredNumbers"
        :key="i"
        :style="i === filteredNumbers.length - 1 && { border: 'none' }"
        class="number">
        <div :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ number.gsm }}</div>
        <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'check d-flex align-items-center justify-center']">
          <input class="d-none" type="radio" v-model="number.checked" name="filter" :value="number.checked">
          <div class="checkbox-element">
            <div v-if="checked == number.checked" class="checked position-relative">
              <div class="black-shadow"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show message if no valid numbers -->
      <div v-if="filteredNumbers.length === 0"
        :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'no-numbers-msg']">
        {{ lang === 'ar' ? 'لا توجد أرقام صالحة (09)' : 'No valid numbers (09)' }}
      </div>

      <button @click="addNewNumber" :class="[lang === 'ar' ? 'bold-ar flex-row-reverse' : 'bold-en', 'add-btn mt-5']">
        {{ $t('profile.addBtn') }}
        <span :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'mx-3']"> + </span>
      </button>
      <button :disabled="load" @click="logout" class="logout">
        <div class="d-flex align-items-center justify-content-center">
          <div v-if="load" class="spinner-border" role="status">
          </div>
          <img v-if="!load" class="login-arrow" src="../../assets/icons/logout-arrow.svg" />
          <img v-if="!load" class="login-line" src="../../assets/icons/logout-line.svg" />
        </div>
        <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('logout') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import utils from '../../shared/utils'
import $ from 'jquery'
import UserNumbersRepository from '../../repositories/UserNumbersRepository'
import UserNameRepository from '../../repositories/UserNameRepository'
import LogoutRepository from '../../repositories/LogoutRepository'
import ms from '../../utils/messeging'
export default {
  name: 'WelcomeMenu',
  data () {
    return {
      logOutRepo: new LogoutRepository(),
      userNameRepo: new UserNameRepository(),
      userNumbersRepo: new UserNumbersRepository(),
      desc: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam',
      reverseDialog: utils.changeDialogStatus,
      height: 0,
      isRegistered: localStorage.getItem('gsm'),
      checked: null,
      lang: this.$lang,
      numbers: [],
      name: '',
      logoutRepo: new LogoutRepository(),
      load: false
    }
  },
  computed: {
    // Filter numbers to only show those starting with 09
    filteredNumbers () {
      return this.numbers.filter(number => {
        return number.gsm && number.gsm.toString().startsWith('09')
      })
    }
  },
  created () {
    if (this.$store.state.user.gsm) {
      this.getUser()
      this.fetchNumbers()
    }
    this.$watch(() => {
      return this.$store.state.forbidden
    }, (val) => {
      this.fetchNumbers()
    })
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('#welcome_menu').css('font-family', 'Mtn-arabic-regular') : $('#welcome_menu').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.desc').css('font-family', 'Mtn-arabic-regular') : $('.desc').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('#welcome_menu .dialog-title').css('font-family', 'Mtn-arabic-bold') : $('#welcome_menu .dialog-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('#welcome_menu .rec-button').css('font-family', 'Mtn-arabic-bold') : $('#welcome_menu .rec-button').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.items').css('font-family', 'Mtn-arabic-regular') : $('.items').css('font-family', 'Mtn-regular')
    })
    this.height = window.innerHeight
    window.addEventListener('resize', () => {
      this.height = window.innerHeight
    })
  },
  methods: {
    // Validate if number starts with 09
    isValidNumber (number) {
      if (!number) return false
      return number.toString().startsWith('09')
    },

    // Handle profile click with validation
    handleProfileClick () {
      const selectedNumber = this.$store.state.selectedNumber || localStorage.getItem('selectedNum')

      if (!this.isValidNumber(selectedNumber)) {
        const message = this.$lang === 'ar'
          ? 'هذه الخدمة متوفرة فقط على التطبيق'
          : 'This service is only available on the app'

        ms.errorMessage(message)
        return
      }

      this.$router.push('/profile')
      this.$store.state.welcomeMenu = false
    },

    async getUser () {
      try {
        const formData = new FormData()
        formData.append('gsm', localStorage.getItem('gsm'))
        const response = await this.userNameRepo.post(formData)
        if (response.status === 200) {
          this.name = response.data.data.name
        }
      } catch (e) {
        console.log(e)
      }
    },
    async fetchNumbers () {
      try {
        const response = await this.userNumbersRepo.get()
        if (response.status === 200) {
          if (response.data.length) {
            this.numbers = []
            for (let i = 0; i < response.data.length; i++) {
              this.numbers.push({
                gsm: response.data[i].gsm,
                checked: i
              })
              // Only set checked if number starts with 09
              if (response.data[i].gsm === this.$store.state.selectedNumber &&
                  response.data[i].gsm.toString().startsWith('09')) {
                this.checked = i
              }
            }
            // If no checked number was set, try to find one
            if (this.checked === null && this.filteredNumbers.length > 0) {
              // Set the first filtered number as checked
              this.checked = this.filteredNumbers[0].checked
              this.$store.state.selectedNumber = this.filteredNumbers[0].gsm
              localStorage.setItem('selectedNum', this.filteredNumbers[0].gsm)
            }
          } else {
            this.empty = true
          }
        }
      } catch (e) {
        this.error = true
      }
    },
    closeOutside () {
      this.$store.state.welcomeMenu = false
      this.$emit('close')
    },
    addNewNumber () {
      this.$store.state.addNewNumber = true
      this.$store.state.registerDialog = true
    },
    checkNumber (i, gsm) {
      // Only allow checking numbers that start with 09
      if (gsm.toString().startsWith('09')) {
        this.checked = i
        this.$store.state.selectedNumber = gsm
        localStorage.setItem('selectedNum', gsm)
      }
    },
    async logout () {
      this.load = true
      try {
        const response = await this.logoutRepo.post()
        if (response.data.status === 200) {
          if (this.$route.path !== '/home') {
            this.$router.push('/home')
          }
          ms.successMessage(response.data.message)
          localStorage.removeItem('gsm')
          localStorage.removeItem('token')
          localStorage.removeItem('selectedNum')
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        ms.errorMessage('Something went wrong')
      }
      this.load = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";

#welcome_menu {
  border-radius: 20px;
  padding: 2rem 1rem;
  width: 360px;
  position: fixed;
  top: 100px;
  z-index: 499000;
  overflow-y: auto;
  max-height: calc(100vh - 120px) !important;
  backdrop-filter: blur(10px);
  background-image: linear-gradient(to bottom, rgb(242, 242, 242, 0.9), rgb(225, 225, 225, 0.9));
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
}

@media screen and (max-width: 800px) {
  #welcome_menu {
    width: 300px !important;
    height: auto !important;
  }
}

.left-menu {
  left: 4vw;
}

.right-menu {
  right: 4vw;
}

.dialog-title {
  margin-bottom: 1rem;
  color: $--yellow;
  font-size: 20px !important;
}

.desc {
  font-size: 13px;
  margin-bottom: 1rem;
}

.yellow-back {
  background: $--yellow;
}

.rec-button {
  position: relative;
  height: 45px;
  width: 100%;
  color: #00678F;
  font-size: 15px;
  border-radius: 15px;
  cursor: pointer;
  color: $--black;
}

.white-b {
  position: absolute;
  top: 0.7px;
  left: 0.7px;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  border-top: 3.2px solid rgba(255, 255, 255, 0.7);
  border-left: 3.2px solid rgba(255, 255, 255, 0.7);
  filter: blur(3.6px);
}

.black-outset-1 {
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.15) !important;
  -webkit-box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.15) !important;
  -moz-box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.15) !important;
}

.registered-form {
  text-align: initial;
}

.show-profile {
  text-decoration: underline !important;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* Disabled link style */
.disabled-link {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}

/* No numbers message */
.no-numbers-msg {
  text-align: center;
  padding: 1rem;
  color: rgba(29, 29, 29, 0.6);
  font-size: 14px;
}

.number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.5rem;
  border-bottom: 1px solid #FFFFFF;
  cursor: pointer;
}

.number:last-child {
  border: none !important;
}

.name {
  color: $--yellow;
  font-size: 20px
}

/*------------------ check box ---------------------------*/
.check {
  cursor: pointer;
}

.checkbox-element {
  height: 18px;
  width: 18px;
  border: 2px solid #FFCB05;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checked {
  height: 10px;
  width: 10px;
  background: #FFCB05;
  border-radius: 50%;
}

.black-shadow {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  position: absolute;
  z-index: -1;
  background: rgba(0, 0, 0, .5);
  filter: blur(4px);
  bottom: -1px;
  right: -1px;
}

/*------------------------------------------------------------------------*/
/*------------------------------ button ----------------------------------*/
.add-btn {
  width: 90%;
  height: 55px;
  background: $--yellow;
  margin: 0 auto;
  border-radius: 20px;
  border: 2.5px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.add-btn>span {
  font-size: 18px
}

.add-btn:focus {
  outline: none;
}

/*------------------------------------------------------------------------*/
/*----------------------------- logout -----------------------------------*/
.logout {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70px
}

.logout>span {
  text-underline-offset: 2px;
  text-decoration: underline;
  padding: 0 10px
}

.login-line {
  width: 12px
}

.login-arrow {
  width: 15px
}
</style>
